import RchTxtWdg from './RchTxtWdg';

let SNG_INS = null;

export default class RchTxtMgr {

	constructor(cbw) {
		this.cbkWdg = cbw;
		this.wdgMap = {};
		this.dnmShr = [];
		this.dnmLng = [];
		this.mnmShr = [];
		this.mnmLng = [];
		cbw.addObj('rchTxtMgr', this);
	}

	destroy() {
		if ( SNG_INS === this ) {
			SNG_INS = null;
		}
		this.cbkWdg = null;
		delete this.wdgMap;
		delete this.dnmShr;
		delete this.dnmLng;
		delete this.mnmShr;
		delete this.mnmLng;
	}

	mgrIni(args) {
		const dns = args.dns;
		const dnl = args.dnl;
		const mns = args.mns;
		const mnl = args.mnl;
		if ( dns && (dns.length > 0) ) {
			this.dnmShr = Object.freeze(dns.slice());
		}
		if ( dnl && (dnl.length > 0) ) {
			this.dnmLng = Object.freeze(dnl.slice());
		}
		if ( mns && (mns.length > 0) ) {
			this.mnmShr = Object.freeze(mns.slice());
		}
		if ( mnl && (mnl.length > 0) ) {
			this.mnmLng = Object.freeze(mnl.slice());
		}
	}

	getDayNam(lng) {
		return lng ? this.dnmLng : this.dnmShr;
	}

	getMonNam(lng) {
		return lng ? this.mnmLng : this.mnmShr;
	}

	wdgIni(args) {
		const idw = args.idw;
		const cfg = args.cfg || {};
		if ( idw ) {
			const wdg = rwt.remote.ObjectRegistry.getObject(idw);
			if ( wdg ) {
				const nfo = new RchTxtWdg(this.cbkWdg, idw, wdg, cfg);
				this.wdgMap[idw] = nfo;
			}
		}
	}

	wdgDst(args) {
		const idw = args.idw;
		if ( idw ) {
			const nfo = this.wdgMap[idw];
			if ( nfo ) {
				nfo.destroy();
				delete this.wdgMap[idw];
			}
		}
	}

	wdgUpd(args) {
		const tgt = this._getTgt(args);
		if ( tgt ) {
			tgt.wdgUpd(args);
		}
	}

	wdgInfo(args) {
		const tgt = this._getTgt(args);
		if ( tgt ) {
			tgt.wdgInfo(args);
		}
	}

	wdgGui(args) {
		const tgt = this._getTgt(args);
		if ( tgt ) {
			tgt.wdgGui(args);
		}
	}

	wdgAct(args) {
		const tgt = this._getTgt(args);
		if ( tgt ) {
			tgt.wdgAct(args);
		}
	}

	getWdg(idw) {
		if ( idw ) {
			return this.wdgMap[idw];
		} else {
			return null;
		}
	}

	_getTgt(args) {
		return this.getWdg(args.idw);
	}

	static getInstance() {
		return SNG_INS;
	}

	static createInstance(cbw) {
		if ( !SNG_INS ) {
			SNG_INS = new RchTxtMgr(cbw);
		}
		return SNG_INS;
	}
}
